var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FFC83E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2281 27.3294C34.5119 27.296 34.7703 27.4349 34.8983 27.6493L34.9561 27.7683C34.9825 27.8227 35.0019 27.8806 35.0135 27.9393L35.5648 36.1482L35.5648 36.1495L35.8379 40.2676C35.8455 40.8327 35.9376 41.3926 36.1083 41.9282L36.1287 41.9924L36.1548 42.0544C36.7363 43.4367 38.1216 44.2948 39.6091 44.2335L39.6272 44.2328L39.6452 44.2316L52.913 43.3646C53.0908 43.368 53.2547 43.4371 53.3748 43.5514L53.3803 43.5565C53.4699 43.641 53.5323 43.7515 53.5594 43.8727L53.5664 43.963C53.0198 50.8626 47.9293 56.6328 40.9871 58.1299L40.987 58.1299C34.0069 59.6357 26.8646 56.4496 23.4307 50.3376C22.4468 48.5745 21.8307 46.6301 21.6198 44.622L21.6166 44.5912L21.6121 44.5605C21.5281 43.9891 21.4912 43.4118 21.5018 42.8343L21.5021 42.8194L21.502 42.8046C21.4911 35.37 26.7761 28.9088 34.2281 27.3294Z",
    stroke: "#FFC83E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6718 21.5001L41.6866 21.5008L41.7014 21.5012C49.9838 21.7137 56.9326 27.5706 58.4481 35.4727L58.4382 35.4959L58.4457 35.8198L58.4494 35.9771C58.4453 35.9894 58.4388 36.0009 58.4302 36.0109L58.4284 36.013C58.4113 36.033 58.3894 36.0482 58.3649 36.0572L58.2733 36.0697L42.9668 37.0622L42.941 37.0639L42.9152 37.0665C42.8693 37.071 42.8229 37.0661 42.7791 37.0518C42.7352 37.0376 42.6947 37.0144 42.6603 36.9838L42.6585 36.9823C42.6188 36.9471 42.5906 36.9011 42.5772 36.8502L41.5541 21.6128L41.5551 21.5837C41.5554 21.5743 41.5576 21.5651 41.5615 21.5566C41.5655 21.5481 41.5711 21.5405 41.5781 21.5342L41.5787 21.5336C41.6041 21.5106 41.6376 21.4986 41.6718 21.5001Z",
    stroke: "#FFC83E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyReports);
export default __webpack_public_path__ + "static/media/DailyReports.a46774415cd378bbbf35835a67eb992b.svg";
export { ForwardRef as ReactComponent };